import React, { useEffect, useState } from "react";
import { TextArea, Button, Modal, FilePicker, useToast } from "@veneer/core";
import {
  apiGet,
  apiPost,
  apiPostUploadFiles,
} from "../../../../services/service";
import {
  POST_UPDATE_CASE,
  POST_UPLOAD_ATTACHMENTS,
} from "../../../../services";
import "./update-case.css";
import { HpLogo } from "../../shared-components/hp-logo/hp-logo";
import Uploadfilemodal from "./modal/upload-file-modal";
import { useLocation } from "react-router-dom";
import { setLoading } from "@store/reducers/loadingSlice";
import { useAppDispatch } from "@store/hooks";
import { toast } from "react-toastify";
import { Trans, useTranslation } from 'react-i18next';

interface UpdateCaseProps {
  cancelCaseHandler: () => void;
  submitCaseHandler: (val: any) => void;
  attachedFilesData: any;
  tempAttachedFilesData: any;
  storeTempAttachedFilesHandler: any
}

const UpdateCase: React.FC<UpdateCaseProps> = ({
  attachedFilesData,
  cancelCaseHandler,
  submitCaseHandler,
  tempAttachedFilesData,
  storeTempAttachedFilesHandler
}) => {
  const validFilesCount = attachedFilesData?.Item3?.filter(
    (val: any) => !val?.Value?.includes("Federator")
  ) || [];
  const initialTotalFiles = (validFilesCount?.length || 0) + (tempAttachedFilesData?.length || 0);
  const [isDisabled, setIsDisabled] = useState(true);
  const [updateText, setUpdateText] = useState<string>("");
  // const [totalfilesNumber, setTotalfilesNumber] = useState<string|number>(initialTotalFiles || "");
  const [totalfiles, setTotalfiles] = useState<any>(initialTotalFiles || 0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [storedFileData, setStoredFileData] = useState<any>(tempAttachedFilesData)
  const [upload, setUpload] = useState<File[]>([]);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    storeTempAttachedFilesHandler(storedFileData);
  }, [storedFileData, totalfiles]);


  useEffect(() => {
    const initialTotalFiles = (validFilesCount?.length) + (tempAttachedFilesData?.length || 0);
    setTotalfiles(Number(initialTotalFiles || 0));
  }, [tempAttachedFilesData]);

  const updateCaseHandler = (val: string) => {
    setUpdateText(val);
    setIsDisabled(val.trim().length === 0);
  };
  const handleFileUpload = (files: File[]) => {
    setUpload(files);
  };
  const handleupdate = async () => {
    let isPoly = sessionStorage.getItem("isPoly") ?? "false";
    dispatch(setLoading(true));
    if (upload.length > 0) {
      const formData = new FormData();
      upload?.forEach((file, index) => {
        formData?.append(`uploadedfile_${index + 1}`, file);
      });
      formData?.append("caseid", location?.state?.data?.incidentid || location?.state?.incidentid);
      formData?.append("isPolyCheck", isPoly);
      const response = await apiPostUploadFiles(
        POST_UPLOAD_ATTACHMENTS,
        formData
      );
      setStoredFileData([])
      try {
        dispatch(setLoading(false));
        submitCaseHandler(updateText);
        console.log("File uploaded successfully:", response.data);
      } catch (error) {
        dispatch(setLoading(false));
        submitCaseHandler(updateText);
        console.error("Error uploading file:", error);
      }

    } else {
      submitCaseHandler(updateText);
    }

  };

  const openAttachmentModal = () => {
    const fileCount = validFilesCount?.length;
    if (!isNaN(fileCount) && fileCount < 3) {
      setIsModalOpen(true);
    } else {
      toast.error(t('HPI.CreateCase.js.FileLimit',{defaultValue:'Only 3 files allowed.'}))
    }

  };
  const closeAttchmentModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="update-case-container">
      <h4>{t("HPI.EditCase.btnUpdateCase", { defaultValue: 'Update Case' })}</h4>
      <p className="m-b10" dangerouslySetInnerHTML={{ __html: t("HPI.EditCase.UpdateCase.quote", { defaultValue: `You may add comments or additional information in the field below and click to update case. <br> (Maximum length = 2000 characters)` }) }}>
      </p>

      {/* <p className="m-b10">(Maximum length = 2000 characters)</p> */}

      <TextArea
        name="update-case"
        value={updateText}
        onChange={(e) => updateCaseHandler(e)}
        maxLength={2000}
        placeholder={t('HPI.EditCase.Case.Placeholder.EnterIssueDescription',{defaultValue:'Enter issue description'})}
      />

      <label className="subtitle-regular mt-3">
        {t("HPI.EditCase.Attacment.Attachment", { defaultValue: 'Attachments' })} <span>{`${totalfiles > 0 ? totalfiles +" "+ t('HPI.EditCase.Cs.TotalFiles',{defaultValue:'total files'}) :t('HPI.General.js.NoFile',{defaultValue:'No files attached'}) } `}</span> |{" "}
        <span
          style={{
            color: "#0073a8",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          onClick={openAttachmentModal}
        >
          {t("HPI.EditCase.Attacment.AddAttachment", { defaultValue: 'Add Attachment' })}
        </span>
      </label>

      <div className="footer">
        <Button small onClick={cancelCaseHandler}>
          {t("HPI.Cancel", { defaultValue: 'Cancel' })}
        </Button>

        <Button small disabled={isDisabled} onClick={handleupdate}>
          {t("HPI.EditCase.btnSubmit", { defaultValue: 'Submit' })}
        </Button>
      </div>
      {isModalOpen && (
        <div>
          <div>
            <Modal
              align="center"
              closeButton
              id="modal-id"
              className="warranty-popup"
              show={isModalOpen}
              onClose={closeAttchmentModal}
              header={
                <div className="popup-header">
                  <HpLogo />
                  <h4>{t("HPI.EditCase.Modalattachment", { defaultValue: 'Add Attachment' })}</h4>
                </div>
              }
            >
              <h2 style={{ display: "flex" }}>{t("HPI.EditCase.Modalattachmentaddfiles", { defaultValue: 'Add Files' })}</h2>
              <Uploadfilemodal
                attachedFilesData={upload}
                onClose={() => setIsModalOpen(false)}
                onUpload={handleFileUpload}
                storeFileData={(files: any) => setStoredFileData(files)} // ✅ Fixed prop name
                filesData={storedFileData}
                removeOneFiles={() => { setTotalfiles((prev: number) => prev - 1) }}
                totalfilesCount={totalfiles}
              />
            </Modal>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateCase;
